import React, { useEffect } from "react"
import { Text, Box, Center, Button, PinInput, HStack, PinInputField, Flex } from "@chakra-ui/react"
import Form from "../custom/Form"
import { Image } from "@chakra-ui/react"
import { UseFormReturnType } from "@mantine/form"
import { OTPType } from "../../pages/auth/forgot_password"
import Logo from "../brand/Logo"
import mail_sent from '../../assets/svgs/mail_sent.svg'

const style = {
  backgroundColor: '#313338',
  width: '100%',
  borderRadius: 15,
  paddingTop: 35,
  paddingLeft: 20,
  paddingRight: 20,
  paddingBottom: 90,
  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
}

interface Props {
  handleOTP: (values: OTPType) => void,
  handleResendOtp: () => void,
  count: number,
  otpForm: UseFormReturnType<{ code: string }>,
  isLoading: {
    forgotPassword: boolean;
    resetPassword: boolean;
    otp: boolean;
    resendOtp: boolean;
  }
}

const OTPForm: React.FC<Props> = ({
  handleOTP,
  otpForm,
  isLoading,
  handleResendOtp,
  count
}) => {
  useEffect(() => {
    document.title = "Verify OTP";
  }, [])

  return (
    <Form
      style={style}
      onSubmit={otpForm.onSubmit((values) => handleOTP(values))}
    >
      <Box w="100%" px={[3, 10]}>
        <Box
          textAlign='center'
          fontWeight='bold'
          fontSize={['xl']}
        >
          <Logo color='#B5BAC1' />

          <Box mt={8}>
            <Image
              mx='auto' src={mail_sent}
              width={40} height={40}
            />
          </Box>

          <Text fontSize="lg" color='#B5BAC1' mt={2}>
            Mail Sent!
          </Text>

          <Text 
            fontWeight='light' fontSize="md" color='#B5BAC1' mt={4}
          >
            Please enter the OTP code sent to your email to proceed
          </Text>

          <Box>
            <Center mt={4}>
              <HStack>
                <PinInput
                  {...otpForm.getInputProps('code')}
                  focusBorderColor={otpForm.errors.code ? 'red.500' : '#37A75B'}
                  isInvalid={otpForm.errors.code ? true : false}
                  isDisabled={isLoading.otp}
                  errorBorderColor='red.500' otp
                >
                  <PinInputField
                    color="#B5BAC1"
                  />
                  <PinInputField
                    color="#B5BAC1"
                  />
                  <PinInputField
                    color="#B5BAC1"
                  />
                  <PinInputField
                    color="#B5BAC1"
                  />
                </PinInput>
              </HStack>
            </Center>

            {otpForm.errors.code &&
              <Text fontSize='sm' mt={3} color='red.500'>
                {otpForm.errors.code}
              </Text>
            }
          </Box>
        </Box>

        <Box mt={5} textAlign='center'>
          <Button
            type="submit"
            isLoading={isLoading.otp}
            bg='#37A75B' size="lg"
            w='100%' color='white'
            _hover={{ backgroundColor: '#046425' }
            }>
            Verify OTP
          </Button>

          {!isLoading.otp &&
            <Flex 
              alignItems='center' gap={3} justifyContent='center'
            >
              <Button
                onClick={handleResendOtp}
                fontSize='sm' size='sm'
                isLoading={isLoading.resendOtp} mt={5}
              >
                Resend OTP
              </Button>

              {count > 0 &&
                  <Text 
                  color='#B5BAC1' 
                  fontWeight='bold' 
                  fontSize='lg'
                  mt={5}
                >
                  {count}
                </Text>
              }
            </Flex>
          }
        </Box>
      </Box>
    </Form>
  )
}

export default OTPForm